import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import {
    SearchBarTemplate,
    SearchBarTemplateProps,
} from "./search-bar.templates";

export interface SearchPageTemplateProps extends SearchBarTemplateProps {
    _slotSearchBar?: string;
    _slotSearchResults?: string;
}

export const SearchPageTemplate = ({
    autosuggestEndpoint,
    buttonText,
    navTabContainerSelector,
    placeholder,
    resultsLabel,
    resultTabContainerSelector,
    searchFormSelector,
    searchString,
    _slotSearchBar = "",
    _slotSearchResults = "",
}: SearchPageTemplateProps) => html`
    ${SearchBarTemplate({
        autosuggestEndpoint,
        buttonText,
        navTabContainerSelector,
        placeholder,
        resultsLabel,
        resultTabContainerSelector,
        searchFormSelector,
        searchString,
        _slot: _slotSearchBar,
    })}
    ${typeof _slotSearchResults === "string"
        ? unsafeHTML(_slotSearchResults)
        : _slotSearchResults}
`;
